//
// 打設箇所（placementPlace）の「表示・保存用」の軽い正規化。
//
// この関数の結果は document 側（placement_place / resolved / fixed / JSON内 打設箇所）に
// 永続化されるため、元の読みやすさを保つ範囲に留める:
//   ・英数字の全角→半角統一（例: "１Ｆ" → "1F"）
//   ・文中の全角スペースを半角スペースに統一
//   ・前後のスペースのトリミング
//
// 文中スペースの「完全除去」や NFKC はここでは行わない。
// 完全除去/NFKC を保存値に適用すると "パラレルPC No12" → "パラレルPCNo12"、
// 丸数字 "②" → "2" のように、本来意味のある表記まで壊してしまうため。
// 同一箇所の空白揺れ（"1Fスラブ 1工区" と "1Fスラブ1工区"）の吸収は保存値では行わず、
// test_result のグルーピング時のみ normalizePlacementPlaceForGrouping で行う。
//
export function normalizePlacementPlace(value: string): string {
  return (
    value
      // 英数字の全角を半角へ。全角英数字は対応する半角文字と 0xfee0 のオフセットを持つ
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xfee0))
      // 文中の全角スペース(U+3000)を半角スペースに統一
      .replace(/\u3000/g, ' ')
      // 前後のスペースを除去
      .trim()
  )
}

//
// test_result 生成（グルーピング）専用の正規化。
//
// 軽い正規化（normalizePlacementPlace）に加えて、文中のあらゆる空白を除去する。
// これにより "1Fスラブ 1工区" と "1Fスラブ1工区" を同一のグルーピングキーへ寄せ、
// OCR 由来の空白有無の揺れで同一ロットが別 test_result に分裂するのを防ぐ。
//
// この結果は document 側には保存しない。あくまで test_result の複合ユニークキー生成と
// 「どの帳票を同じ test_result に束ねるか」の突き合わせ時にのみ用いる。
// 保存値（表示に使う値）は normalizePlacementPlace の軽い正規化までに留めることで、
// "パラレルPC No12" のような読みやすい表記を壊さない。
//
export function normalizePlacementPlaceForGrouping(value: string): string {
  return normalizePlacementPlace(value).replace(/\s+/g, '')
}
